import { cn } from '@/lib/cn';
import type { ReactNode } from 'react';

type TooltipSide = 'top' | 'bottom' | 'left' | 'right';

interface TooltipProps {
  label: string;
  shortcut?: string;
  side?: TooltipSide;
  /** wrapper 가 inline-flex 라 자식의 layout 영향 가능. 기본 inline-flex. */
  className?: string;
  children: ReactNode;
}

const sidePositionClass: Record<TooltipSide, string> = {
  top: 'bottom-full left-1/2 -translate-x-1/2 mb-1.5',
  bottom: 'top-full left-1/2 -translate-x-1/2 mt-1.5',
  left: 'right-full top-1/2 -translate-y-1/2 mr-1.5',
  right: 'left-full top-1/2 -translate-y-1/2 ml-1.5',
};

export function Tooltip({ label, shortcut, side = 'bottom', className, children }: TooltipProps) {
  return (
    <span className={cn('group relative inline-flex', className)}>
      {children}
      <span
        role="tooltip"
        className={cn(
          'pointer-events-none absolute z-50 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md',
          'bg-foreground text-background px-2 py-1 text-xs font-medium shadow-md',
          'opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity duration-100 delay-150',
          sidePositionClass[side],
        )}
      >
        {label}
        {shortcut ? (
          <kbd className="font-sans text-[10px] rounded-sm bg-background/15 px-1 py-0.5 text-background">
            {shortcut}
          </kbd>
        ) : null}
      </span>
    </span>
  );
}
